<template>
    <div v-bind:class="checkcolor" class="border-b mb-8 mt-4 text-secondary-text">
        <span v-bind:class="checkcolor" class="inline-block align-bottom border-b-4 pb-2 md:text-2xl text-secondary-text">
            <span class="lang-de">
               <the-text-view :value="$slots.de[0].text"/>
            </span>
            <span class="lang-en">
               <the-text-view :value="$slots.en[0].text"/>
            </span>
        </span>
    </div>
</template>



<script>

    import TheTextView from "./TheTextView";

    export default {
        name: 'theTitle',
        components: {
            TheTextView
        },
        props: {
            parentcolor: String
        },
        computed: {
            checkcolor() {
                switch (this.parentcolor) {
                    case 'orange':
                        return 'border-primary-orange text-primary-orange'
                    case 'white':
                        return 'border-white text-white'
                    default:
                        return 'border-black text-black'
                }
            }
        }
    }
</script>
